import { useContext } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { GreetingColors } from '../../Colors';
import TimeContainer from '../../TimeContainer';
import styles from './comments.module.css';
import { WeekReflectionContext } from './WeekReflectionContext';

export const CommentSection = ({ storyName, isOpen, closeComments }) => {
    let timeOfDay = new TimeContainer().getTimeOfDay();
    const timeOfDayBGColor = GreetingColors[timeOfDay].background;

    const { textInputs, setTextInput, setInputChange, weekReviewManager } = useContext(WeekReflectionContext);
    const location = useLocation();

    const onInput = (e) => {
        setTextInput(prevInput => ({
            ...prevInput,
            [storyName]: e.target.value
        }))
    }

    const onSaveComment = () => {
        setInputChange(true);
        weekReviewManager?.saveReflection(textInputs);
        closeComments();
    }

    return isOpen && (
        <div className={styles.commentSectionBackground} onClick={closeComments}>
            <div className={styles.commentPopup} style={{ background: timeOfDayBGColor }} onClick={(e) => e.stopPropagation()}>
                <textarea className={styles.textarea}
                    placeholder='Add your thoughts...'
                    onChange={onInput}
                    value={textInputs[storyName]}
                    readOnly={location.pathname.includes('share')}
                />
                {!location.pathname.includes('share') &&
                    <button className={styles.saveButton} onClick={onSaveComment}>
                        Add
                    </button>
                }
            </div>
        </div>
    )
}